<template>
  <div>
    <Head title="Ubah Periode Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/scholarships">Periode Beasiswa</Link>
      <span class="font-medium text-indigo-400">/</span>
      Periode {{ $filters.formatShortDate(scholarship.tgl_awal) }} - {{ $filters.formatShortDate(scholarship.tgl_akhir) }}
    </h1>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Awal Pendaftaran</label>
            <Datepicker
              v-model="tgl_awal"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Akhir Pendaftaran</label>
            <Datepicker
              v-model="tgl_akhir"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <text-input
            v-model="form.keterangan"
            :error="form.errors.keterangan"
            class="w-full pb-8 pr-6 lg:w-1/3"
            label="Keterangan"
          />

          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Awal Verifikasi</label>
            <Datepicker
              v-model="tgl_awal_verifikasi"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Akhir Verifikasi</label>
            <Datepicker
              v-model="tgl_akhir_verifikasi"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Pengumuman</label>
            <Datepicker
              v-model="tgl_pengumuman"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Awal Daftar Ulang</label>
            <Datepicker
              v-model="tgl_awal_daftar_ulang"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <div class="flex flex-col w-full pb-8 pr-6 lg:w-1/3">
            <label for="">Tgl. Akhir Daftar Ulang</label>
            <Datepicker
              v-model="tgl_akhir_daftar_ulang"
              :enable-time-picker="true"
              :utc="false"
              class="pt-2"
              format="dd-MM-yyyy HH:mm"
            />
          </div>
          <text-input
            v-model.number="form.kuota_mou"
            type="number"
            :error="form.errors.kuota_mou"
            class="w-full pb-8 pr-6 lg:w-1/3"
            label="Kuota / Kampus"
          />
          <div class="flex w-full pb-8 pr-6 lg:w-1/3">
            <input id="mou" v-model="form.status" type="checkbox" class="mr-2" />
            <label for="mou" class="flex flex-row items-center cursor-pointer">Aktif</label>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Link class="btn-red" :href="`/scholarships`">
            <font-awesome-icon class="mr-2" icon="fas fa-arrow-left" />Kembali
          </Link>
          <loading-button :loading="form.processing" class="ml-auto btn-green" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Datepicker,
  },
  layout: Layout,
  props: {
    scholarship: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        keterangan: this.scholarship.keterangan,
        kuota_mou: this.scholarship.kuota_mou,
        status: this.scholarship.status,
      }),
      tgl_awal: this.scholarship.tgl_awal ? dayjs(this.scholarship.tgl_awal).tz('Asia/Jakarta').toDate() : null,
      tgl_akhir: this.scholarship.tgl_akhir ? dayjs(this.scholarship.tgl_akhir).tz('Asia/Jakarta').toDate() : null,
      tgl_awal_verifikasi: this.scholarship.tgl_awal_verifikasi ? dayjs(this.scholarship.tgl_awal_verifikasi).tz('Asia/Jakarta').toDate() : null,
      tgl_akhir_verifikasi: this.scholarship.tgl_akhir_verifikasi ? dayjs(this.scholarship.tgl_akhir_verifikasi).tz('Asia/Jakarta').toDate() : null,
      tgl_pengumuman: this.scholarship.tgl_pengumuman ? dayjs(this.scholarship.tgl_pengumuman).tz('Asia/Jakarta').toDate() : null,
      tgl_awal_daftar_ulang: this.scholarship.tgl_awal_daftar_ulang ? dayjs(this.scholarship.tgl_awal_daftar_ulang).tz('Asia/Jakarta').toDate() : null,
      tgl_akhir_daftar_ulang: this.scholarship.tgl_akhir_daftar_ulang ? dayjs(this.scholarship.tgl_akhir_daftar_ulang).tz('Asia/Jakarta').toDate() : null,
    }
  },
  methods: {
    update() {
      const formData = {
        ...this.form,
        tgl_awal: this.tgl_awal ? dayjs(this.tgl_awal).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_akhir: this.tgl_akhir ? dayjs(this.tgl_akhir).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_awal_verifikasi: this.tgl_awal_verifikasi ? dayjs(this.tgl_awal_verifikasi).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_akhir_verifikasi: this.tgl_akhir_verifikasi ? dayjs(this.tgl_akhir_verifikasi).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_pengumuman: this.tgl_pengumuman ? dayjs(this.tgl_pengumuman).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_awal_daftar_ulang: this.tgl_awal_daftar_ulang ? dayjs(this.tgl_awal_daftar_ulang).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
        tgl_akhir_daftar_ulang: this.tgl_akhir_daftar_ulang ? dayjs(this.tgl_akhir_daftar_ulang).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss') : null,
      }

      this.$inertia.put(`/scholarships/${this.scholarship.id}`, formData)
    },
  },
}
</script>
